module.exports = __webpack_public_path__ + "static/media/state-banner-3.1fc5b2df.png";